<template>
  <div class="payment-union-container">
    <div class="payment-union-content">
      <div class="payment-union-header">
        <h2>云闪付支付设置</h2>
        <p>配置云闪付支付相关参数</p>
      </div>
      
      <!-- 帮助文档 -->
      <div class="help-document">
        <span class="help-title">帮助文档</span>
        <el-button type="text" @click="helpVisible = !helpVisible" style="float: right;">
          {{ helpVisible ? '收起' : '展开' }}
        </el-button>
      </div>
      <el-card class="help-card" shadow="hover" style="margin-bottom: 20px;">
        <div v-if="helpVisible" class="help-content">
          <h4>云闪付开通流程：</h4>
          <ol>
            <li>登录<a href="https://merchant.unionpay.com/" target="_blank">银联商务商户平台</a></li>
            <li>注册并认证商户账号</li>
            <li>在商户平台中创建应用</li>
            <li>获取商户号、终端号等参数</li>
            <li>配置回调地址</li>
            <li>下载API证书</li>
          </ol>
          <h4>参数说明：</h4>
          <ul>
            <li><strong>商户号</strong>：银联商务分配的商户号</li>
            <li><strong>终端号</strong>：银联商务分配的终端号</li>
            <li><strong>API密钥</strong>：在银联商务平台设置的API密钥</li>
            <li><strong>API证书</strong>：从银联商务平台下载的证书文件</li>
            <li><strong>回调地址</strong>：支付结果通知的回调地址，必须是外网可访问的地址</li>
          </ul>
        </div>
      </el-card>
      
      <el-form :model="form" label-width="120px">
        <el-form-item label="启用云闪付">
          <el-switch v-model="form.enabled" active-text="启用" inactive-text="禁用"></el-switch>
        </el-form-item>
        
        <el-form-item label="商户号">
          <el-input v-model="form.merchantId" placeholder="请输入商户号"></el-input>
        </el-form-item>
        
        <el-form-item label="终端号">
          <el-input v-model="form.terminalId" placeholder="请输入终端号"></el-input>
        </el-form-item>
        
        <el-form-item label="API密钥">
          <el-input v-model="form.apiKey" placeholder="请输入API密钥"></el-input>
        </el-form-item>
        
        <el-form-item label="API证书路径">
          <el-input v-model="form.certPath" placeholder="请输入API证书路径"></el-input>
        </el-form-item>
        
        <el-form-item label="回调地址">
          <el-input v-model="form.notifyUrl" placeholder="请输入回调地址"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="saveSettings">保存设置</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PaymentUnion',
  data() {
    return {
      form: {
        enabled: false,
        merchantId: '',
        terminalId: '',
        apiKey: '',
        certPath: '',
        notifyUrl: 'https://www.weixiaobuai.com/api/pay/union/notify'
      },
      helpVisible: false
    }
  },
  mounted() {
    this.loadSettings()
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get('/admin/config/payment-union')
        if (response.data.code === 200) {
          this.form = response.data.data
        }
      } catch (error) {
        console.error('加载云闪付配置失败:', error)
      }
    },
    async saveSettings() {
      try {
        const response = await axios.put('/admin/config/payment-union', this.form)
        if (response.data.code === 200) {
          this.$message.success('设置保存成功')
        } else {
          this.$message.error('保存失败')
        }
      } catch (error) {
        console.error('保存云闪付配置失败:', error)
        this.$message.error('保存失败')
      }
    },
    resetForm() {
      this.loadSettings()
      this.$message.info('表单已重置')
    }
  }
}
</script>

<style scoped>
.payment-union-container {
  padding: 20px 0;
}

.payment-union-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.payment-union-header {
  margin-bottom: 30px;
}

.payment-union-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.payment-union-header p {
  font-size: 14px;
  color: #aaa;
  margin: 0;
}

.help-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.help-content {
  padding: 10px 0;
}

.help-content h4 {
  margin-top: 15px;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
}

.help-content ol, .help-content ul {
  margin-left: 20px;
  color: #333;
  line-height: 1.5;
}

.help-content li {
  margin-bottom: 5px;
}

.help-content strong {
  color: #333;
  font-weight: 600;
}

.help-content a {
  color: #409EFF;
  text-decoration: none;
  font-weight: 500;
}

.help-content a:hover {
  text-decoration: underline;
}

.help-title {
  color: #ff4d4f;
  font-weight: bold;
}

.help-document {
  margin-bottom: 10px;
  padding: 10px;
  background: rgba(255,255,255,0.05);
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.1);
}

.help-document::after {
  content: '';
  display: table;
  clear: both;
}
</style>